import {combineReducers} from "redux";
import {ViewportReducer} from "./viewport";
import {MapReducer} from "./map";
import { UIReducer } from './ui';
import {IApplicationState} from "../types";

export const rootReducer = combineReducers<IApplicationState>({
    viewport: ViewportReducer,
    map: MapReducer,
    ui: UIReducer,
});
